import { z } from 'zod';
import '@apexdesigner/schema-tools';

export const pdfRenderResult = z
  .object({
    pdf: z.string().describe('PDF The PDF bytes, base64 encoded.'),

    diagnostics: z
      .unknown()
      .nullable()
      .optional()
      .presentAs('json')
      .describe(
        'Diagnostics What evaluation reported, each with its position in the template.',
      ),
  })
  .describe(
    'A rendered template design: the PDF and whatever evaluation reported. Under the default `fail` policy the diagnostics are warnings only, since an error would have failed the render instead.',
  )
  .as('PdfRenderResult', { embedded: true });

export { pdfRenderResult as pdfRenderResultSchema };
